import { NgModule } from '@angular/core';
import { TShirtSizesFormModuleDeprecated } from 'ag-common-svc/lib/components/t-shirt-sizes-form-deprecated/t-shirt-sizes-form-module-deprecated.module';

import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { SizesComponent } from './sizes.component';
import { ModalWindowModule } from 'ag-common-svc/lib/components/modal-window/modal-window.module';
import { ButtonWithIndicatorModule } from 'ag-common-svc/lib/components/button-with-indicator/button-with-indicator.module';
import { TShortSizeSelectBoxModule } from 'ag-common-svc/lib/components/t-short-size-select-box/t-short-size-select-box.module';
import { AgEditorToolbarModule } from 'ag-common-svc/lib/components/ag-editor-toolbar/ag-editor-toolbar.module';
import { TShirtSizesFormModule } from "ag-common-svc/lib/components/t-shirt-sizes-form/t-shirt-sizes-form.module";

@NgModule({
  imports: [
    SharedModule,
    ModalWindowModule,
    ButtonWithIndicatorModule,
    TShortSizeSelectBoxModule,
    AgEditorToolbarModule,
    TShirtSizesFormModuleDeprecated,
    TShirtSizesFormModule,
  ],
  declarations: [SizesComponent],
  exports: [SizesComponent],
})
export class SizesModule {}
